import script from "./BracketHistoryView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BracketHistoryView.vue?vue&type=script&lang=ts&setup=true"

import "./BracketHistoryView.vue?vue&type=style&index=0&id=1d0e801b&lang=css"

const __exports__ = script;

export default __exports__